export enum ActionIcons {
  NONE,
  LOCK,
  UNLOCK,
  LOCK_DISABLED,
  LOCK_TEMPORARY,
  UNLOCK_DISABLED,
  BUNDLE,
  FLANGES,
  LOADING,
  WARNING,
  ERROR,
  PRINCIPAL,
  NEW_ITEM,
  DELETE_ITEM,
  SELECTED_ITEM,
  FOCUSED_ITEM
}
